/**
 * Created by xy on 2018/8/27.
 */
import React,{Component} from "react"
import {NavBar,Modal,Toast} from 'antd-mobile';
import { invoiceDetail,invoiceBack } from "../../../service/invoiceService";
import connect from "react-redux/es/connect/connect";
import moment from 'moment';
import './style.less';
import { Document , Page} from 'react-pdf'
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class paperInvoice extends Component{
    constructor(props) {
        super(props);
        console.log(this.props);
        this.state={
            data:[],
            numPages: null,
        }
    }
    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }
    componentDidMount() {
       this.getInvoiceDetail();
    }
    
    getInvoiceDetail(){
        let params = {
            source:6,
            token:this.props.userInfo.token,
            data:{
                id:this.props.location.state.id,
            }
        };
        Toast.loading("正在加载");
        invoiceDetail(params).then(res=>{
            console.log(res)
            if(res.data.code == "0000"){
                Toast.hide();
                this.setState({data:res.data.data,});
            }else{
                Toast.info(res.data.msg,3);
            }
        }).catch(function (error) {
            console.log(error);
        });
    }
    backInvoice(){
        Toast.loading('',0);
        let params = {
            source:6,
            token: this.props.userInfo.token,
            data: {id:this.props.location.state.id,}
        };
        invoiceBack(params).then((res) => {
            if (res.data.code === '0000') {
                Toast.info("撤回成功",2,()=>this.props.history.goBack());
            } else {
                Toast.info(res.data.msg,3);
            }
        })
    }
    reback(i){
        if(i.status == 0 && i.receiveType == 2 && i.invoiceType == 1){
            return  <div className="btn"  onClick={()=>
                        Modal.alert('提示', '您确定要撤回吗?', [
                            { text: '取消'},
                            { text: '确定', onPress: () => this.backInvoice()},
                        ])}>撤回</div>
        } 
        if(i.status == 0 && i.invoiceType == 0){
            return  <div className="btn"  onClick={()=>
                        Modal.alert('提示', '您确定要撤回吗?', [
                            { text: '取消'},
                            { text: '确定', onPress: () => this.backInvoice()},
                        ])}>撤回</div>
        } 
    }
    render() {
        const {data} = this.state;
        return (
            <div className="paperInvoice">
            {this.state.show === true ?
                <div className="bgblack" onClick={() => {this.setState({show: !this.state.show})}}>
                    <Document
                        className="pdf"
                        file={data.pdfUrl}
                        onLoadSuccess={this.onDocumentLoadSuccess}
                    >
                        <Page pageNumber={1} />
                    </Document>
                </div>
                : null}

                <NavBar
                        className="navBar"
                        mode="light"
                        icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()}/>}
                    >
                    发票详情
                </NavBar>

                <div className="warp">
                    {/* 头部内容    */}
                    <div className="InvoiceBox">
                        <div className="content">
                            <div>发票抬头</div>
                            <div>{data.invoiceUp}</div>
                        </div>
                        <div className="content">
                            <div>发票税号</div>
                            <div>{data.invoiceNumber}</div>
                        </div>
                        <div className="content">
                            <div>发票类型</div>
                            <div>{data.invoiceType == 0 ? '电子发票' : '纸质发票'} <span  style={{paddingLeft:10}}>{data.receiveType == 2 ? '自提' : '邮寄'}</span></div>
                        </div>
                        <p></p>
                        <div className="content">
                            <div>申请日期</div>
                            <div>{data.applyTimeStr}</div>
                        </div>
                        <div className="content">
                            <div>开票状态</div>
                            <span>{data.status == 0 ?  '未开票' : '已开票'}</span>
                        </div>
                        <div className="content">
                            <div>抬头类型</div>
                            <div>{data.upType == 0 ? '个人' :'企业'}</div>
                        </div>
                        <div className="content">
                            <div>发票内容</div>
                            <div>*运输服务*客运服务费用</div>
                        </div>
                        <div className="content">
                            <div>发票金额</div>
                            <div>{'¥'+data.invoiceAmount}</div>
                        </div>
                        <div className="content">
                            <div>备注信息</div>
                            <div>{data.noteResult == null ? '无' : data.noteResult}</div>
                        </div>

                         <div>
                            {
                                data.invoiceType == 0 && data.status == 1 ?
                                    <div className="viewInvoice">
                                        <a onClick={() => {this.setState({show: !this.state.show})}}>查看发票<i className="icon iconfont icontiaozhuan"/></a>
                                    </div>
                                : null
                            }
                        </div>
                    </div>
                    {data.invoiceType == 1 && data.receiveType === 1? (
                        <div className="info">
                            <div className="box">
                                <div className="title">收&nbsp;&nbsp;件&nbsp;&nbsp;人</div>
                                <div className="content">{data.recipient}</div>
                            </div>
                            <div className="box">
                                <div className="title">联系电话</div>
                                <div className="content">{data.contactPhone}</div>
                            </div>
                            <div className="box">
                                <div className="title">收件地址</div>
                                <div className="content">{data.contactAddress}</div>
                            </div>
                            <div className="box">
                                <div className="title">快递公司</div>
                                <div className="content">{data.courierCompany}</div>
                            </div>
                            <div className="box">
                                <div className="title">快递单号</div>
                                <div className="content">{data.courierId}</div>
                            </div>
                        </div>
                    ):
                    data.invoiceType == 0 ? <div className="info">
                        <div className="box">
                            <div className="title">电子邮箱</div>
                            <div className="content">{data.email}</div>
                        </div>
                        <div className="box">
                            <div className="title">接收电话</div>
                            <div className="content">{data.userPhone}</div>
                        </div>
                    </div> : null

                }
                {data.status == 1 ? <div className="btn"><a href={data.pdfUrl} >下载PDF</a></div> :this.reback(data)}

                </div>

               
            </div>
           
        )
    }
}


// WEBPACK FOOTER //
// ./src/container/Invoice/paperInvoice/index.js